export default {
  private: false,
  template_name: 'Tabs',
  allowed_types: [
    'gh_float'
  ],
  model: {
    template_id: 'gh_tabs',
    name: '',
    icon_id: '',
    class: 'gh_tabs gh_title gh_nav_tabs_top',
    priority: 0,
    container_id: 0,
    content: []
  },
  html: `
    <div class="gh_tabs_block">
      <div class="gh_tabs_align">
        <div class="gh_tabs_block_nav" ng-init="lists = item.content; $parent.tab_id = 0">

          <span class="gh_tabs_block_nav_btn" ng-class="{'--active_tab' : $parent.tab_id == $index}" ng-click="$parent.tab_id = $index" ng-repeat="item in lists">
            <span class="gh_tabs_block_nav_btn_icon" gh-icon="{{item.icon_id ? item.icon_id : 'box'}} a7a9b3 30px normal"></span>
            <span class="gh_tabs_block_nav_btn_title">{{item.name}}</span>
          </span>

          <div style="clear:both"></div>
        </div>

        <div class="gh_tabs_block_list" ng-init="lists = item.content">
          <div ng-if="$parent.tab_id == $index" class="gh_tabs_block_list_item" ng-class="item.class" ng-repeat="item in lists" ng-include="item.template_id + '_editor_light'"></div>
        </div>

        <div style="clear:both"></div>
      </div>
    </div>`,
  icon: 'tabs'
};
